import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

function AccounTabs( props ) {
  let uploadSrv = ( window.location.host === "localhost:3000" ? "./public/api/appUpload.php" : "/api/appUpload.php" );

    return (
    <div className='container'>
      <form id="appAcctProfileForm" action={uploadSrv} method="POST" encType="multipart/form-data" data-modified={false}>
        <Tabs
          id="appAccountProfile"
          activeKey={props.tabKey}
          onSelect={(k) => props.onTabSelect(k)}
          className="mb-3"
        >
          <Tab  eventKey="profile" title="Profile">
            <div id="appAcctProfileDetails"></div>
          </Tab>
          <Tab eventKey="owner" title="Owner">
            <div id="appAcctOwnerDetails"></div>
          </Tab>
          <Tab eventKey="menus" title="Menus">
            Tab content for Menus
          </Tab>
          <Tab eventKey="options" title="Options">
          <div id="appAcctOptionsDetails"></div>
          </Tab>
        </Tabs>
      </form>
    </div>
  );
}

export default AccounTabs;